{
  "id": 44,
  "location": "paris",
  "difficulty": "normal",
  "moves": 25,
  "kinds": 6,
  "goals": [
    { "type": "collect", "kind": "macaron", "count": 40 },
    { "type": "collect", "kind": "cookie", "count": 40 }
  ],
  "stars": [5120, 6200],
  "board": [
    ". . . . . . . .",
    ". . . . . . . .",
    ". . . . . . . .",
    ". . . . . . . .",
    ". . . . . . . .",
    ". . . . . . . .",
    ". . . . . . . .",
    ". . . . . . . ."
  ],
  "calibration": { "runs": 1000, "winRate": 0.702, "movesLeft": 4.6, "closeLosses": 0.096, "target": 0.68 }
}
